import { render, staticRenderFns } from "./default.vue?vue&type=template&id=7d647945&scoped=true&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=7d647945&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d647945",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Bottom: require('/app/components/bottom.vue').default})
